import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Persons } from './types'
import { RootState } from '../types'

export const state: Persons = {
  persons: [],
  filterPersons: [],
  responseMessage: '',
  responseError: false,
  currentPerson: {
    first_name: '',
    last_name: '',
    emails: [{ email: '' }],
    roles: [],
    phones: [],
    profile: [],
    ibutton: '',
    created_by: ''
  },
  thingsAssignments: []
}

const namespaced = true

export const persons: Module<Persons, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
